import React from 'react';
import { FadeIn, Section } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const BenefitsSection = () => {
  const benefits = ['Menos inflamación abdominal', 'Más energía desde la mañana', 'Menos antojos', 'Mejor digestión', 'Mente más clara', 'Ropa que vuelve a cerrar'];
  return <Section bg="white" data-id="element-17">
      <FadeIn data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-19">
          En 14 días puedes notar:
        </h2>
      </FadeIn>

      <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-20">
        {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-21">
            <div className="flex items-center gap-4 p-4 rounded-xl bg-brand-cream/30 hover:bg-brand-cream transition-colors border border-transparent hover:border-brand-teal/20" data-id="element-22">
              <CheckCircle2 className="w-8 h-8 text-brand-teal flex-shrink-0" data-id="element-23" />
              <p className="text-xl text-gray-800 font-medium" data-id="element-24">{benefit}</p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};